import { render, staticRenderFns } from "./OverviewAddressList.vue?vue&type=template&id=df8090e6"
import script from "./OverviewAddressList.vue?vue&type=script&lang=js"
export * from "./OverviewAddressList.vue?vue&type=script&lang=js"
import style0 from "./OverviewAddressList.vue?vue&type=style&index=0&id=df8090e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports